/**
 * 
 * SmileNav.js
 * 
 */


import React, { Component } from "react";
import { Navbar } from 'react-bootstrap';

// components
import { SmileLinks } from './SmileLinks';


export default class SmileNav extends Component {

  static displayName = SmileNav.name;



  navAnimate(id_name) {
    let element = document.getElementById(id_name); 
    if (element != null)
        element.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"}); 
  }  


  render() {
    return (

      <Navbar style={{ backgroundColor: "#FFF" }} className="shadow-lg" fixed="top" expand="lg"  variant="dark">


        <Navbar.Brand onClick={() => this.navAnimate("home") } style={{ paddingLeft: '50px' }}>
          <img
            src="/assets/logo/logo2.png"
            width="130"
            height="40"
            alt="Smile Logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle variant="dark" style={{ backgroundColor: "#99ffff", borderColor: "" }} aria-controls="responsive-navbar-nav" />
        
        <Navbar.Collapse  id="responsive-navbar-nav" style={{paddingTop: '10px', paddingRight: '50px'}}>
          <SmileLinks />
        </Navbar.Collapse>
        
      </Navbar>

    );
  }
}
